export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/dist/cjs.js??ref--6-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchList.vue?vue&type=style&index=0&id=30794c8f&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchList.vue?vue&type=style&index=0&id=30794c8f&scoped=true&lang=css&
// module id = rNwS
// module chunks = 0